import React from 'react';
import Button from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import ReadOnlyTextField from '../../../Components/readOnlyTextField/readOnlyTextField'
import {SortByProperty} from '../../../services/Functions'
import Select from '../../../Components/select/select'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css"

export default class delete_motivo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            reason: [],
            reasonsId: [],
            id_reason: null,
            reload:false,
            show:false,
            description:"",
            code:"",
            notification: false,
            notification_type: 'success',
            notification_message: ''
        }
    }

    componentDidMount = () => {
        Api.get('/reasons-stop/').then((resp) => {
            let arr = []
            resp.data.response.forEach(element => {
                arr.push({ value: element.id, label:element.code+"- "+element.description  })
            });
            
            this.setState({ reason: arr,reasonsId:[...resp.data.response]})
            this.state.reason.sort(SortByProperty("value"))
        })
    }

    getSelectedReason = (childData) => {
        let arrCodeDesc = childData
        const {id,description,code} = this.state.reasonsId.find(v => v.id == childData)
        this.setState({ id_reason: id,description:description,code:code})
    }

    sendData = async (id) => {
        if (id !== null) {
            await Api.delete(`/reasons-stop/${id}`).then(resp => {
                this.setState({notification: true, notification_message: "Motivo deletado com sucesso!"});
                setTimeout(()=>{
                    return window.location.reload();
                },2000)
            }).catch((error) => {
                if (error.response) {
                    this.setState({ message: ""+error.response.data, show: true })
                }
            })
        }else{
            this.setState({ message: "Necessário preencher todos os campos.", show: true })
        }
    }
    callbackfunction = () => { this.setState({ show: false }) }

    render() {
        let { show, message,reload, notification, notification_message, notification_type } = this.state
        return (
            <div className='box'>
                {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                <div className="input_fields_del_reason form">
                <h4>Deletar Motivo</h4>
                    {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} reload={reload} /> : null}
                    <div className='inputs'>
                        <div className='selectDelReason element'><Select autoSelect={true} label="Selecionar motivo" arrData={this.state.reason} handleSelect={this.getSelectedReason} /></div>
                        <div className='tf1DelReason element' ><ReadOnlyTextField title="Código" showValue={this.state.code}/></div>
                        <div className='tf2DelReason element' ><ReadOnlyTextField title="Descrição" showValue={this.state.description}/></div>
                    </div>
                    <div className='btnDelReason submitButton'><Button title="Deletar" icon="del" parentCallback={() => this.sendData(this.state.id_reason)} /></div>
                </div>
            </div>
        );
    }
}